import { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import CheckboxTree from "react-checkbox-tree";
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import { redirectToPages } from "../../../../../_helpers/Helpers";
import * as actions from "../../_redux/modules/ModulesAction";
import { 
  Card, 
  CardBody, 
  CardHeader, 
  ModalProgressBar 
} from "../../../../../_metronic/_partials/controls";

export function ModulesCard() {
  const [expanded, setExpanded] = useState();

  const dispatch = useDispatch();
  const { listLoading, isSuccess, type, modules } = useSelector(
    (state) => ({
      listLoading: state.modules.listLoading,
      isSuccess: state.modules.isSuccess,
      type: state.modules.type,
      modules: state.modules.entities
    }),
    shallowEqual
  );
  
  useEffect(() => {
    dispatch(actions.getModules());
    return () => dispatch(actions.cleanModulesState());
  }, [dispatch]);

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

  // Belli Bir Modülü Elde Eder
  const getModule = (id) => {
    dispatch(actions.getModule(id));
  }

  const nodes = [];
  modules.forEach(module => {
    if (module.parentId === 0) {
      const node = {
        value: module.id,
        label: module.order + ". " + module.name,
        showCheckbox: false
      };      
      const childModules = modules.filter(childModule => childModule.parentId === module.id);

      if (childModules.length > 0) {
        node.children = [];        
        childModules.forEach(childModule => {            
          const childNode = {
            value: childModule.id,
            label: childModule.order + ". " + childModule.name,
            showCheckbox: false
          };
          node.children.push(childNode);          
        });    
      }        
      nodes.push(node);
    }    
  });

  return (
    <Card>
      {listLoading && <ModalProgressBar />}
      <CardHeader title="Modül Listesi" />
      <CardBody>        
        <CheckboxTree            
          nodes={nodes}
          iconsClass="fa5"
          expanded={expanded}
          onExpand={setExpanded}
          onClick={e => getModule(e.value)}
        />
      </CardBody>
    </Card>
  );
}